<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col">
                    <h2>Nuova scheda Film</h2>
                </div>
                <div class="col text-right">
                    <button v-if="!readonly"
                            @click.prevent="save"
                            class="btn btn-success">Salva
                    </button>
                    <button v-if="!readonly"
                            @click.prevent="reset"
                            class="btn btn-warning">Ripristina
                    </button>
                </div>
            </div>

            <film-card-form :form="form" :readonly="readonly" :type="type"/>

        </div>
    </section>
</template>

<script>
import sharedState from "../sharedState";
import FilmCardForm from "../components/FilmCardForm.vue"

export default {
    name: "FilmCardAdd",
    components: {
        FilmCardForm,
    },
    data() {
        return {
            sharedState: sharedState,
            form: new Form(),
            readonly: false,
            type: 'create',
        }
    },
    methods: {
        async save() {
            this.$isLoading(true)
            try {
                let response = await this.form.post(window.baseUrl + '/film-cards')
                this.$destroy();
                this.$isLoading(false)
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                }).finally();
                await this.$router.replace({path: '/film-card/' + response.data.data.id});
            } catch (e) {
                console.error(e)
                this.$isLoading(false)
                Toast.fire({
                    icon: 'error',
                    title: 'Errore: impossibile salvare il modulo.'
                }).finally();
            }
        },
        reset() {
            this.form = new Form()
        }
    }
}
</script>

<style scoped>

</style>
